import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import ScrollToDirective from '@directives/scroll-into-view.directive';
import { DotLoader } from '@feedback/loader/dot-loader.component';
import { WellComponent } from '@presentational/well/well.component';
import { WooPercentFormatter } from '@scripts/woo_components.module/directives/woo-percent-formatter.directive';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { WooTableColumn } from '@src/shared/presentational/woo-table/woo-table-column/woo-table-column.component';
import { WooTableComponent } from '@src/shared/presentational/woo-table/woo-table.component';
import { DefaultMmsValueSetting } from './components/mms_admin/default-mms-value-setting.component';
import { InvalidMmsDayAdmin } from './components/mms_admin/invalid-mms-day-admin/invalid-mms-days-admin.component';
import { MmsAdmin } from './components/mms_admin/mms-admin.component';
import { PublisherGroupSettings } from './components/publisher_group_settings/publisher-group-settings.component';
import { SystemMessages } from './components/system_messages/system-messages.component';
import { SystemSettingsForm } from './components/system_settings_form/system-settings-form.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DotLoader,
    WellComponent,
    ScrollToDirective,
    WooTableComponent,
    WooTableColumn,
    WooPercentFormatter,
    WooComponentsModule,
  ],
  providers: [],
  declarations: [
    DefaultMmsValueSetting,
    MmsAdmin,
    InvalidMmsDayAdmin,
    SystemMessages,
    PublisherGroupSettings,
    SystemSettingsForm,
  ],
  exports: [SystemSettingsForm, PublisherGroupSettings, SystemMessages, MmsAdmin],
})
export class WooSystemSettingsModule {}
